import { IHowToFile } from '../interfaces/howTo/IHowToFile';
import { IHowToVideo } from '../interfaces/howTo/IHowToVideo';

export const files: IHowToFile[] = [
  {
    id: 1,
    title: 'SUP Accounting Tool Travel Management',
    descriptionEn: 'How to create a travel request and apply for reimbursement of travel expenses',
    descriptionDe: 'So erstellen Sie einen Reiseantrag und beantragen die Erstattung von Reisekosten',
    fileName: 'Accounting Tool_Travel Management.pdf',
    url: '',
  },
  {
    id: 2,
    title: 'How To Controlling',
    descriptionEn: 'SUP Billing-Tool (Abrechnungstool) towards our partners',
    descriptionDe: 'SUP Billing-Tool (Abrechnungstool) gegenüber unseren Partnern',
    fileName: 'How to Controlling.pdf',
    url: '',
  },
];

export const videos: IHowToVideo[] = [
  { id: 1, title: 'Controlling Abrechnungstool Englisch', fileName: 'Howto Controlling Eng.mp4', url: '' },
  { id: 1, title: 'Controlling Abrechnungstool Deutsch', fileName: 'Howto Controlling De.mp4', url: '' },
  { id: 2, title: 'Accounting Tool Englisch', fileName: 'Howto Accountingtool Eng.mp4', url: '' },
  { id: 3, title: 'Accounting Tool Deutsch', fileName: 'Howto Accountingtool De.mp4', url: '' },
];
